import React from "react";

interface ListItem {
  title: string;
  description: React.ReactNode;
}

interface HeadingContent {
  type: "heading";
  text: string;
}

interface ParagraphContent {
  type: "paragraph";
  text: React.ReactNode; // Змінено на ReactNode для підтримки JSX
}

interface ListContent {
  type: "list";
  items: ListItem[];
}

type Content = HeadingContent | ParagraphContent | ListContent;

const parsePrivacyNotice = (text: string): Content[] => {
  const lines = text.split("\n");
  const structuredContent: Content[] = [];
  let currentList: ListItem[] | null = null;

  // Функція для обробки тексту та заміни email на <a>
  const processText = (input: string): React.ReactNode => {
    const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
    const matches = input.match(emailRegex);

    if (!matches) return input;

    const result: React.ReactNode[] = [];
    let lastIndex = 0;

    matches.forEach((email, index) => {
      const startIndex = input.indexOf(email, lastIndex);
      if (startIndex > lastIndex) {
        result.push(input.slice(lastIndex, startIndex));
      }
      result.push(
        <a key={`${email}-${index}`} href={`mailto:${email}`}>
          {email}
        </a>
      );
      lastIndex = startIndex + email.length;
    });

    if (lastIndex < input.length) {
      result.push(input.slice(lastIndex));
    }

    return result;
  };

  lines.forEach((line) => {
    line = line.trim();
    if (!line) return;

    if (/^\d+\.\s/.test(line)) {
      if (currentList) {
        structuredContent.push({ type: "list", items: currentList });
        currentList = null;
      }
      structuredContent.push({ type: "heading", text: line });
      return;
    }

    if (line.startsWith("●")) {
      if (!currentList) currentList = [];
      const listItem = line.slice(2).trim();
      const [title, ...description] = listItem.split(": ");
      currentList.push({
        title: title || "",
        description: processText(
          description.length ? description.join(": ") : ""
        ), // Обробка email у description
      });
      return;
    }

    if (currentList) {
      structuredContent.push({ type: "list", items: currentList });
      currentList = null;
    }
    structuredContent.push({ type: "paragraph", text: processText(line) });
  });

  if (currentList) {
    structuredContent.push({ type: "list", items: currentList });
  }

  return structuredContent;
};

export default parsePrivacyNotice;
